import { C } from "../lib/colors";

// Thin centered footer for auth + onboarding pages that don't use PageShell.
// Gives the user a way out — Privacy / Terms / Contact links — and grounds
// them with the copyright line so they don't feel stranded in a chrome-less
// modal-y page.

export const MinimalFooter = ({ onNavigate }) => (
  <footer style={{
    borderTop: `1px solid ${C.border}`,
    padding: "18px 5%",
    marginTop: "auto",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    flexWrap: "wrap", gap: 10,
  }}>
    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.25)" }}>
      © {new Date().getFullYear()} Media on Auto Pilot
    </div>
    <div style={{ display: "flex", gap: 14 }}>
      {[["Privacy", "privacy"], ["Terms", "terms"], ["Contact", "contact"]].map(([l, p]) => (
        <button key={p} onClick={() => onNavigate(p)}
          style={{
            background: "none", border: "none",
            color: "rgba(255,255,255,0.35)", fontSize: 11, cursor: "pointer",
            fontFamily: "'Instrument Sans',sans-serif", transition: "color 0.2s", padding: 0,
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = C.muted}
          onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.35)"}>
          {l}
        </button>
      ))}
    </div>
  </footer>
);
